import { useTheme } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";


Profile.Full = ({ name, size, sx, image, ...props }) => {
	const style = {
		root: { alignItems: "center" },
		avatar: { width: size, height: size }
	};

	return (
		<Box gap={2} sx={{ ...style.root, ...sx }} {...props}>
			<Avatar src={image} sx={style.avatar} />
			<Typography variant="caption" color="text.primary">{name}</Typography>
		</Box>
	);
};

export default function Profile({ image, children, ...props }) {
	const theme = useTheme();
	const style = {
		root: {
			p: 0,
			gap: 0.5,
			"&.Mui-disabled": {
				color: "white"
			}
		},
		avatar: {
			m: theme.spacing(1)
		}
	};
	return (
		<Button {...props} sx={{ ...style.root, ...props.sx }} disabled={!props.onClick}>
			{children}
			<Avatar src={image} sx={style.avatar} />
		</Button>
	);
}